import { defineStore } from 'pinia'
import http from '@/services/http'
import { useRootStore } from '@/stores/root'
import baseMenu from '@/components/navigation/menu'

// Port modulo Vuex `navigation` → Pinia.
// Le mutation root SET_LOADING / SET_SIDE_MENU diventano azioni del root store.
export const useNavigationStore = defineStore('navigation', {
  actions: {
    async fetchSideMenu({ forceRefresh }) {
      const rootStore = useRootStore()
      rootStore.setIsLoading(true)
      try {
        const rawMenu = await http.request(
          {
            method: 'get',
            path: '/navigation',
          },
          forceRefresh,
        )
        const sideMenu = rawMenu.reduce((acc, item) => {
          const menuItem = baseMenu.find((i) => i.code === item.codmnu)
          if (!menuItem) {
            return [
              ...acc,
              {
                code: item.codmnu,
                name: item.desmnu,
                label: item.desmnu,
                separator: Number(item.codmnu) >= 9000,
              },
            ]
          }
          return [...acc, { ...menuItem, label: item.desmnu }]
        }, [])
        rootStore.setSideMenu([...sideMenu, ...baseMenu.filter((item) => !!item.static)])
      } finally {
        rootStore.setIsLoading(false)
      }
    },
    async fetchNavigationSections(code) {
      const rootStore = useRootStore()
      rootStore.setIsLoading(true)
      try {
        const response = await http.request({
          method: 'get',
          path: `/navigation/${code}`,
        })
        rootStore.setIsLoading(false)
        return response
      } catch {
        rootStore.setIsLoading(false)
        return false
      }
    },
  },
})
